export default {
  SET_TARGETS: (state, { targets }) => {
    state.targets = targets
  }
}
